import { Component, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { AppProfileService } from 'src/app/services/profile.service';
import { CallApiService } from '../../services/api-action.service';
import { AsyncClickDirective } from '../../directives/async-click.directive';
import { Observable, tap } from 'rxjs';

@Component({
    imports: [FormsModule, AsyncClickDirective],
    selector: 'app-tfa',
    templateUrl: './tfa.component.html'
})
export class TwoFactorAuthenticationComponent {
  private router = inject(Router);
  private profileService = inject(AppProfileService);
  private callApiService = inject(CallApiService);

  verificationCode: string;
  error: string;

  verify(): Observable<unknown> {
    return this.callApiService
      .callWithToasts$(
        this.profileService.verifyTfa(this.verificationCode),
        null,
        $localize`Die Zwei-Faktor-Authentifizierung konnte nicht durchgeführt werden.`
      )
      .pipe(
        tap(() => {
          this.router.navigate(['/']);
        })
      );
  }
}
